// BuildingDefaults_Hardcoded.ts — the terminal source of the §3 fallback chain (Buildings Set1,
// §2.7). These are the last-resort values when no Room/Level/Building/prototype provides a field.
// Material recipe ids map onto existing built-ins (`wood`, `concrete`, `cobblestone`, `marble`);
// the plan §7.4 recipes (brick, plaster, glass, ...) will slot in where appropriate once P6 adds
// them. This file is the single source the fallback engine bottoms out at, so keep it a plain
// (deeply-resolved, no-nulls) object.
import {DoorSwing, RoofStyle} from "./BuildingShared.js";

export type ResolvedBuildingDefaults = {
	level: {floorThickness: number; wallHeight: number};
	room: {wallThickness: number; hasFloor: boolean; hasCeiling: boolean};
	window: {width: number; height: number; sillHeight: number; paneDivisionsX: number; paneDivisionsY: number};
	door: {width: number; height: number; swing: DoorSwing; openAngle: number};
	opening: {width: number};
	roof: {style: RoofStyle; gableAlongShorter: boolean; pitch: number; eaveOverhang: number; fasciaDepth: number; soffitEnabled: boolean; ridgeHeightMax: number; latticeStep: number};
	materials: {
		floorTop: string; floorUnderside: string; floorEdge: string; ceiling: string;
		wallExterior: string; wallInterior: string; wallTop: string; wallReveal: string;
		roofSurface: string; roofFascia: string; roofSoffit: string;
		doorFrame: string; doorSlab: string; doorHardware: string;
		windowFrame: string; windowGlass: string;
	};
};

export const HARDCODED_BUILDING_DEFAULTS: ResolvedBuildingDefaults = {
	level:  {floorThickness: 0.25, wallHeight: 2.7},
	room:   {wallThickness: 0.2, hasFloor: true, hasCeiling: true},
	window: {width: 1.2, height: 1.4, sillHeight: 0.9, paneDivisionsX: 2, paneDivisionsY: 1},
	door:   {width: 0.9, height: 2.05, swing: DoorSwing.inRight, openAngle: 0},
	opening:{width: 1.2},
	roof:   {style: RoofStyle.hip, gableAlongShorter: false, pitch: 0.5, eaveOverhang: 0.4, fasciaDepth: 0.2, soffitEnabled: true, ridgeHeightMax: 8, latticeStep: 0.5},
	materials: {
		floorTop: "wood", floorUnderside: "plaster", floorEdge: "concrete",
		ceiling: "plaster",
		wallExterior: "brick", wallInterior: "plaster", wallTop: "concrete", wallReveal: "concrete",
		roofSurface: "roofShingles", roofFascia: "wood", roofSoffit: "wood",
		doorFrame: "wood", doorSlab: "wood", doorHardware: "metalStandingSeam",
		windowFrame: "wood", windowGlass: "glass",
	},
};
